import { useRef } from 'react'
import { useInView } from 'framer-motion'
import { MomBooksContentBar } from './MomBooksContentBar'

interface Props {
  books: string[]
  max: number
}

export const MomBooksContentBarMotion = ({ books, max }: Props) => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, amount: 0.9 })

  return (
    <MomBooksContentBar
      ref={ref}
      books={books}
      max={max}
      show={inView}
      animate
    />
  )
}
